import { makeStyles, shorthands } from '@fluentui/react-components';

export const useImageBannerContainerStyle = makeStyles({
  topBanner: {
    width: '100%',
    display: 'flex',
    ...shorthands.padding('36px'),
    flexDirection: 'column',
    alignItems: 'flex-start',
    ...shorthands.gap('24px'),
    alignSelf: 'stretch',
    ...shorthands.borderRadius('8px'),
    backgroundImage: 'linear-gradient(97deg, #E4E2F3 7.52%, #E3EDF3 91.2%), linear-gradient(102deg, rgba(217, 204, 223, 0.25) -0.35%, rgba(231, 222, 227, 0.25) 53.37%, rgba(116, 92, 185, 0.25) 104.98%)',
  },
  texts: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('8px'),
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    textAlign: 'left',
  },
  pageName: {
    lineHeight: '37px',
    fontSize: '28px',
    fontWeight: 600,
  },
  descriptions: {
    fontSize: '16px',
    lineHeight: '21px',
    fontWeight: 400,
  },
  entryCard: {
    width: '100%',
  },
});
